module.exports = __webpack_public_path__ + "static/media/activity_graph.767b9168.svg";